<template lang="html">
  <section class="app-update-subscriber">
    <p class="text-success" v-if="messageSubmission">
      <strong>{{ messageSubmission }}</strong>
    </p>
    <p v-if="!getCurrentElement">
      Please go first to the "<a href="#" @click="navigateAway('read')"><strong><em>Read</em></strong></a>"
      tab and select the award you would like to update.
    </p>
    <form v-else @submit.prevent="onSubmit" class=" text-left" :class="$v.dataForm.$invalid ? '':'was-validated'">
      <div class="form-group d-flex">
        <label for="subscriberEmail" class="w-25 align-self-center">* Email :</label>
        <div class="w-100">
          <input :class="$v.dataForm.subscriberEmail.$error ? 'is-invalid': ''" type="email"
                 @blur="$v.dataForm.subscriberEmail.$touch() || (dataForm.subscriberEmail = (dataForm.subscriberEmail === '') ? savedData.email : dataForm.subscriberEmail)"
                 v-model="dataForm.subscriberEmail"
                 class="form-control" id="subscriberEmail" required>
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.subscriberEmail.email">Please enter a valid email address !</div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <div class="w-25 align-self-center">* Unsubscribed: </div>
        <div class="w-90">
          <div class="custom-control custom-radio custom-control-inline">
            <input v-model="dataForm.subscriberUnsubscribed" value="1" type="radio"
                   id="subsribedYes" class="custom-control-input">
            <label class="custom-control-label" for="subsribedYes">YES</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input v-model="dataForm.subscriberUnsubscribed" value="0" type="radio"
                   id="subsribedNo" class="custom-control-input">
            <label class="custom-control-label" for="subsribedNo">NO</label>
          </div>
        </div>
      </div>
      <div class="mt-4 mb-4 text-center">
        <button :class="$v.dataForm.$invalid ? 'cursor-pointer-disabled':''"
                type="submit" class="btn btn-success" :disabled="$v.dataForm.$invalid">
          Submit
        </button>
        <button type="button" class="btn btn-danger ml-3" @click="resetForm">
          Reset
        </button>
      </div>
    </form>
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from "vuex";
import {FORM_SUBSCRIBERS_VALIDATIONS} from '../../validations/formSubscribers'

export default {
  name: 'UpdateSubscriber',
  props: [],
  mounted () {},
  created () {
    this.readOneData()
      .then(data => {
        this.savedData = data;
        this.dataForm.subscriberEmail = this.savedData.email;
        this.dataForm.subscriberUnsubscribed = this.savedData.unsubscribed;
      })
      .catch()
  },
  validations: FORM_SUBSCRIBERS_VALIDATIONS,
  data () {
    return {
      savedData : null,
      dataForm: {
        subscriberEmail: undefined,
        subscriberUnsubscribed: 0
      },
      messageSubmission: ""
    }
  },
  methods: {
    ...mapActions([
      'setOperation',
      'setCrudComponent',
      'readOneData',
      'updateData'
    ]),
    navigateAway(tab) {
      this.setOperation(tab);
      this.setCrudComponent('app-' + tab + '-' + this.getComponent);
    },
    onSubmit () {
      const formData = {
        email : (this.getCurrentElement) ? this.getCurrentElement.id : '',
        unsubscribed: this.dataForm.subscriberUnsubscribed
      };
      this.updateData(formData)
        .then(data => {
          this.messageSubmission = data;
          setTimeout( () => this.messageSubmission = '', 5000);
        })
        .catch()
    },
    resetForm () {
      this.dataForm.subscriberEmail = this.savedData.email;
      this.dataForm.subscriberUnsubscribed = this.savedData.unsubscribed;
    }
  },
  computed: {
    ...mapGetters([
      'getComponent',
      'getCurrentElement'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-update-subscriber {}
</style>



// WEBPACK FOOTER //
// src/components/subscribers/UpdateSubscriber.vue